<div class="container-fluid">
  <header>
    <app-nav-menu></app-nav-menu>
  </header>
  <!--Begin page content-->
  <main role="main" class="backg">
    <div class="container-fluid ">
      <div class="row">
        <div class="col-sm-12 col-md-6 left_content">
          <div class="left_con">
            <h2 class=" welcome1message">Welcome to PATEMPO!</h2>
            <p class="mt-4 text-left text-secondary welcome2message">PATEMPO™ responds to a critical question that any patent applicant or agent has: “Assuming I can obtain a patent, how long will it take to get granted?”. It allows to automatically estimate the pendency of your patent applications in China and South-East Asia and to instantly access to our recommendations on how to expedite their examination, publication and grant.</p>
          </div>
        </div>
        <div class="col-sm-12 col-md-6 right_content">
          <div class="right_con">
            <div class="row">
              <div class="col-12 text-left ">
                <h3 class="text-secondary forgot-passwordTitle"><strong>Forgot Password</strong></h3>
              </div>
              <p class="col-12 mt-4 text-left text-secondary welcome2message  welcome3message">Please check your email to reset your password.</p>
              <div class="col-12 mt-4 mb-3  text-left text_dont reminderMessageContent" align="center">
                Back to <a class="sign-up" [routerLink]="['/login']">LOGIN</a>
              </div>

            </div>
            
          </div>
        </div>
      </div>
    </div>
  </main>
</div>





